import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import {
    SectionOneImageOneTextBody,
    SectionOneImageOneTextDetails,
} from "types/api/blocks/sectionOneImageOneText";

function useSectionOneImageOneTextApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionOneImageOneText = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionOneImageOneTextDetails> => {
        return get<PathParamsWithId, undefined, SectionOneImageOneTextDetails>({
            url: "/blocks/section-one-image-one-text/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionOneImageOneText = React.useCallback((body: SectionOneImageOneTextBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionOneImageOneTextBody, null>({
            url: "/blocks/section-one-image-one-text",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionOneImageOneText = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-one-image-one-text/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionOneImageOneText,
        saveSectionOneImageOneText,
        deleteSectionOneImageOneText
    };
}

export default useSectionOneImageOneTextApi;